import { render, staticRenderFns } from "./InstagramAccountCard.vue?vue&type=template&id=607e3478&"
import script from "./InstagramAccountCard.vue?vue&type=script&lang=js&"
export * from "./InstagramAccountCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports